import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Snackbar, Button } from '@material-ui/core';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import store from '../../redux/store';
import Groups from '../../containers/Groups';
import MarketplaceListings from '../../containers/MarketplaceListings';
import Seating from '../../containers/Seating';
import Inventory from '../../containers/Inventory';
import MetaPanel from '../../containers/MetaPanel';
import MetaHeader from '../../containers/MetaHeader';
import NotesContainer from '../../containers/Notes';
import { PricingProvider, usePricing } from '../../context/pricing-context';
import { MetaProvider, useMetaContext } from '../../context/meta-context';
import { auditTrail } from '../../services/killshot';
import '../../styles/Pricing.scss';
import TableLoader from '../../components/TableLoader';
import ValidateUser from '../../components/UserStatus';
import { refreshGroups } from '../../redux/actions/refresh-groups';
import { useTabVisibilityTracking } from '../../shared/utils/DatadogActiveTag';

const APP_PADDING = 10;
const ONE_COLUMN = 12;
const THREE_COLUMN = 4;
const CONTAINER_SPACING = 1;

const styles = makeStyles(() => ({
  root: {
    padding: APP_PADDING,
  },
  autoComplete: {
    padding: 10,
    display: 'flex',
  },
  paperSectionGeneric: {
    marginTop: '8px',
  },
  pricingFlexContainer: {
    display: 'flex',
    alignItems: 'stretch',
    alignContent: 'stretch',
  },
  pricingColumnFlexContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    alignContent: 'stretch',
  },
  notesSummary: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    direction: 'row',
  },
  notesDetails: {
    padding: '5px',
  },
}));

const inventoryPanel = {
  isExpanded: false,
  colSpan: THREE_COLUMN,
};

const mapPanel = {
  isExpanded: false,
  colSpan: 3,
};

const Container = styled.div``;
function Pricing(props) {
  const { match } = props;
  const { groupedListings, listings, skyboxId } = usePricing();
  const classes = styles();
  const [message, setMessage] = useState('');
  const [counterMeta, setCounterMeta] = useState(0);
  const [refreshCounter, setRefreshCounter] = useState(0);

  const handleCloseSnackBar = () => setMessage('');
  const refresh = () => {
    setCounterMeta(counterMeta + 1);
    store.dispatch(refreshGroups(skyboxId));
    handleCloseSnackBar();
  };

  const setRefresh = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  useTabVisibilityTracking('pricing', 'event/pricing/?');

  const action = (
    <Button color="secondary" size="small" onClick={refresh}>
      Refresh
    </Button>
  );

  return (
    <Container className={classes.root}>
      <div>
        <ValidateUser />
        <Grid container spacing={CONTAINER_SPACING} className={classes.pricingFlexContainer} style={{ zIndex: 800 }}>
          <Grid item xs={ONE_COLUMN} sm={ONE_COLUMN} md={5} className={classes.pricingColumnFlexContainer}>
            <MetaPanel
              eventId={match.params.event_id}
              skyboxId={skyboxId}
              forceUpdate={counterMeta}
              setRefresh={setRefresh}
            />
            <Groups
              eventId={match.params.event_id}
              inventory={groupedListings}
              skyboxId={skyboxId}
              listings={listings}
            />
          </Grid>
          <Grid
            item
            xs={ONE_COLUMN}
            sm={ONE_COLUMN}
            md={inventoryPanel.colSpan}
            className={classNames(classes.paperSectionGeneric, classes.pricingColumnFlexContainer)}
          >
            <Inventory
              eventId={match.params.event_id}
              skyboxId={skyboxId}
              forceRefresh={refreshCounter}
              setRefresh={setRefresh}
            />
            {!skyboxId ? <TableLoader /> : <MarketplaceListings skyboxId={skyboxId} />}
          </Grid>
          <Grid
            item
            xs={ONE_COLUMN}
            sm={ONE_COLUMN}
            md={mapPanel.colSpan}
            className={classes.pricingColumnFlexContainer}
          >
            <NotesContainer eventId={match.params.event_id} />
            <Seating />
          </Grid>
        </Grid>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(message)}
        onClose={handleCloseSnackBar}
        message={message}
        action={action}
        TransitionProps={{
          onExited: handleCloseSnackBar,
        }}
      />
    </Container>
  );
}

Pricing.propTypes = {
  match: PropTypes.object.isRequired,
};

function MetaHead() {
  const { eventMeta, loadingEventMeta } = useMetaContext();

  useEffect(() => {
    const auditEvent = 'open';
    if (eventMeta.event_name) {
      auditTrail(eventMeta.event_id, auditEvent, 'event');
      const eventDate = moment(eventMeta.event_date_local).format('MM/DD/YYYY');
      document.title = `${eventMeta.event_name}, ${eventMeta.venue.name}, ${eventDate}`;
    }
  }, [eventMeta]);
  return <MetaHeader eventMeta={eventMeta} isLoading={loadingEventMeta} />;
}

const MainPricing = props => {
  return (
    <div>
      <MetaProvider {...props}>
        <MetaHead />
      </MetaProvider>
      <PricingProvider {...props}>
        <Pricing {...props} />
      </PricingProvider>
    </div>
  );
};

export default MainPricing;
